/*
 * Copyright (c) 2020.
 * ducnq
 */

import { USERS_SUCCESS, USERS_FAILURE } from "./../../../../types/index";

/**
 * @param {*} state
 * @param {*} action
 */
const UsersReducer = (state = {}, action) => {
  if (action.payload === undefined || action.payload === false) return state;

  switch (action.type) {
    case USERS_SUCCESS:
      return { ...state, action };
    case USERS_FAILURE:
    default:
      return state;
  }
};

export { UsersReducer };
